import * as React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import { CustomAppBar } from './headerStyled';
import Profile from '../Components/utilities/Profile/Profile';
import Navigation from '../Components/utilities/Navigation/Navigation';
import Logo from '../Components/utilities/Logo/Logo';



function Header() {
    return (
        <CustomAppBar>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Box>
                        <Logo/>
                    </Box>
                    <Navigation/>
                    {/* <SettingsRoundedIcon className="settingIcon" />
                    <HelpRoundedIcon className="helpIcon" /> */}
                    <Profile />
                </Toolbar>
            </Container>
        </CustomAppBar>
    );
}
export default Header;